import React, { Component } from 'react'
import { connect } from 'react-redux'
import { ProjectListHeader, RadarChart, BarChart } from '../../../components'
import { back, push } from '../../../actions/nav-actions'
import { fetchEvaluatingResults, fetchActualResults } from '../../../api';

class EvaluateContext extends Component {
  state = {
    project: {},
    is_loading: false,
    error: undefined,
    data: {},
    actual_data: {}
  }
  constructor(props) {
    super(props);
    this.getParams = this.getParams.bind(this);
    this.getRadarData = this.getRadarData.bind(this);
    this.renderCharts = this.renderCharts.bind(this);
  }
  getParams() {
    return this.props.match.params || {};
  }
  componentDidMount() {
    const params = this.getParams();
    this.setState({ is_loading: true, error: undefined }, () => {
      fetchEvaluatingResults(this.props.user.token,
        params.organization,
        params.code
      )
        .then((data) => {
          fetchActualResults(
            this.props.user.token,
            params.organization,
            params.code
          ).then((actual_data) => this.setState({ is_loading: false, data, actual_data }));
        })
        .catch(err => this.setState({ is_loading: false, error: err }))
    });
  }
  getBarChart(goal, index, subgoal_index) {
    if (!this.state.data.options) return null;
    let quantitative_indicators = goal.indicators.filter(i => i.result.type === 'quantitative');
    return {
      indicators: quantitative_indicators
    }
  }
  getRadarData(goal, index, subgoal_index) {
    if (!this.state.data.options || !this.state.actual_data.options) return null;
    const quantitative_indicators = goal.indicators.filter(i => i.result.type === 'quantitative');
    let actual_goal = undefined;
    if (!subgoal_index) {
      actual_goal = this.state.actual_data.options.goals.filter(g => g._id === goal._id)[0];
    } else {
      actual_goal = this.state.actual_data.options.goals[index].subgoals.filter(g => g._id === goal._id)[0];
    }
    let actual_quantitative_indicators = []
    if (actual_goal) {
      actual_quantitative_indicators = actual_goal.indicators.filter(i => i.result.type === 'quantitative')
    }

    actual_quantitative_indicators = quantitative_indicators.map((element, index) => {
      if (actual_quantitative_indicators[index]) return actual_quantitative_indicators[index];
      let indicator = { result: {}, ...actual_quantitative_indicators[index] }
      indicator.result.input = 0;
      return { ...indicator }
    });

    return {
      indicators: {
        projected: quantitative_indicators.map(i => {
          i.result.input = Number(i.result.input) || 0
          return i;
        }),
        actual: actual_quantitative_indicators.map(i => {
          i.result.input = Number(i.result.input) || 0
          return i;
        })
      }
    }
  }
  renderCharts(goal, goal_index, subgoal_index) {
    let titlegoal = subgoal_index !== undefined ? `SUBGOAL ${goal_index + 1}.${subgoal_index + 1}` : `GOAL ${goal_index + 1}`;
    let idgoal = subgoal_index !== undefined ? `subgoal-${goal_index + 1}-${subgoal_index + 1}` : `goal-${goal_index + 1}`;
    return (
      <React.Fragment>
        <BarChart
          id={`bar${idgoal}`}
          title={`INDICATORS FOR ${titlegoal}:`}
          description="Providing sub-grants in Eastleigh that instigate stronger identity and self-confidence of youth to allow them to reject extremism through increased propensity among youth for moderation and non-violence"
          data={this.getBarChart(goal, goal_index, subgoal_index)} />
        <RadarChart
          id={`radar${idgoal}`}
          title={`SURVEY (A) FOR ${titlegoal}:`}
          description="Assesing individual risk and protective rating"
          data={this.getRadarData(goal, goal_index, subgoal_index)} />
      </React.Fragment>
    )
  }
  render() {
    if (this.state.error) return <span>{this.state.error.message}</span>
    if (!this.state.data.results || this.state.is_loading) return <span>Loading data...</span>

    return (
      <React.Fragment>
        <div>
          {this.state.data.options.goals.map((goal, goal_index) => {
            return (
              <div>
                <ProjectListHeader style={{ marginTop: 32 }} title={"Goal " + (goal_index + 1) + ": " + goal.name} />
                <ProjectListHeader style={{ marginTop: 32, marginBottom: 32 }} title="ACTIVITIES" dark />
                <div className="col-12 img-thumbnail">
                  {goal.activities.map((activity, activity_index) => {
                    return (
                      <div>
                        <ProjectListHeader style={{ marginTop: 32, marginBottom: 32 }} title={"Activity " + (activity_index + 1) + ": " + activity.activity.name} dark />
                        <p>{activity.relation}</p>
                      </div>
                    )
                  })}
                </div>
                <ProjectListHeader style={{ marginTop: 32, marginBottom: 32 }} title="INDICATORS" dark />
                {this.renderCharts(goal, goal_index)}
                <div className="row">
                  <div className="col-4">
                    <span className="text-center btn-block">OUTPUT</span>
                    {goal.indicators.filter(i => i.result.category === "output" && i.result.type !== 'quantitative').map((indicator) => {
                      return (
                        <div>
                          <span className="text-primary">{indicator.indicator.measure}</span>
                          <p>{indicator.result.input}</p>
                        </div>
                      )
                    })}
                  </div>
                  <div className="col-4">
                    <span className="text-center btn-block">OUTCOME</span>
                    {goal.indicators.filter(i => i.result.category === "outcomes" && i.result.type !== 'quantitative').map((indicator) => {
                      return (
                        <div>
                          <span className="text-primary">{indicator.indicator.measure}</span>
                          <p>{indicator.result.input}</p>
                        </div>
                      )
                    })}
                  </div>
                  <div className="col-4">
                    <span className="text-center btn-block">IMPACT</span>
                    {goal.indicators.filter(i => i.result.category === "impact" && i.result.type !== 'quantitative').map((indicator) => {
                      return (
                        <div>
                          <span className="text-primary">{indicator.indicator.measure}</span>
                          <p>{indicator.result.input}</p>
                        </div>
                      )
                    })}
                  </div>
                </div>
                {goal.subgoals.map((subgoal, subgoal_index) => {
                  return (
                    <div>
                      <ProjectListHeader style={{ marginTop: 32 }} title={"Subgoal " + (goal_index + 1) + "." + (subgoal_index + 1) + ": " + goal.name} />
                      <ProjectListHeader style={{ marginTop: 32, marginBottom: 32 }} title="ACTIVITIES" dark />
                      <div className="col-12 img-thumbnail">
                        {subgoal.activities.map((activity, activity_index) => {
                          return (
                            <div>
                              <ProjectListHeader style={{ marginTop: 32, marginBottom: 32 }} title={"Activity " + (activity_index + 1) + ": " + activity.activity.name} dark />
                              <p>{activity.relation}</p>
                            </div>
                          )
                        })}
                      </div>
                      <ProjectListHeader title="INDICATORS" style={{ marginTop: 32, marginBottom: 32 }} dark />
                      {this.renderCharts(subgoal, goal_index, subgoal_index)}
                      <div className="row">
                        <div className="col-4">
                          <span className="text-center btn-block">OUTPUT</span>
                          {subgoal.indicators.filter(i => i.result.category === "output" && i.result.type !== 'quantitative').map((indicator) => {
                            return (
                              <div>
                                <span className="text-primary">{indicator.indicator.measure}</span>
                                <p>{indicator.result.input}</p>
                              </div>
                            )
                          })}
                        </div>
                        <div className="col-4">
                          <span className="text-center btn-block">OUTCOME</span>
                          {subgoal.indicators.filter(i => i.result.category === "outcomes" && i.result.type !== 'quantitative').map((indicator) => {
                            return (
                              <div>
                                <span className="text-primary">{indicator.indicator.measure}</span>
                                <p>{indicator.result.input}</p>
                              </div>
                            )
                          })}
                        </div>
                        <div className="col-4">
                          <span className="text-center btn-block">IMPACT</span>
                          {subgoal.indicators.filter(i => i.result.category === "impact" && i.result.type !== 'quantitative').map((indicator) => {
                            return (
                              <div>
                                <span className="text-primary">{indicator.indicator.measure}</span>
                                <p>{indicator.result.input}</p>
                              </div>
                            )
                          })}
                        </div>
                      </div>
                    </div>
                  )
                })}
              </div>
            )
          })}
        </div>
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => ({ user: state.authReducer.user });

const mapDispatchToProps = dispatch => ({
  back() {
    dispatch(back())
  },
  push(routeName) {
    dispatch(push(routeName))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(EvaluateContext);


// WEBPACK FOOTER //
// ./src/routers/Projects/Formularies/EvaluatingResultsFormularies.js